module.exports = __webpack_public_path__ + "a6ead12d0ce84a63ff9700b4bd4d979e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/logo/witeboard.svg
// module id = 162
// module chunks = 0